import {
  Step,
  StepIndicator,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
  Box,
  Flex,
  Image,
  Text,
  Icon,
  Button,
} from '@chakra-ui/react'
import CloseIcon from '@assets/svgs/learn/close.svg'
import DocumentIcon from '@assets/svgs/learn/document_2.svg'
import {useEffect, useState} from 'react'
import CheckActiveIcon from '@assets/svgs/learn/check_active.svg'
import CheckCompleteIcon from '@assets/svgs/learn/check_complete.svg'
import {Modal} from 'antd'
import {useLocation, useNavigate} from 'react-router-dom'
import {PATH} from '@utils/Const'
import {ReactComponent as ExclamationCircle} from '@assets/svgs/exclamation-circle.svg'
import {useDispatch, useSelector} from 'react-redux'
import {
  updateIsShowModalExitFlow,
  updateIsShowReportErrorForm,
} from '@redux/shared/shared'
import {getFeedbackExitFlowType} from '@utils'

const Header = ({
  vocabularyData,
  currentVocabulary,
  currentIndexVocabulary,
}: {
  vocabularyData: any
  currentVocabulary: any
  currentIndexVocabulary: any
}) => {
  const {dataFeedbackOverview} = useSelector((state: any) => state.shared)
  const [indexProgress, setIndexProgress] = useState<number>(0)
  const [isOpenModal, setIsOpenModal] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const {entry_point} = location.state || {}
  const dispatch = useDispatch()
  useEffect(() => {
    if (!vocabularyData) {
      return
    }

    const i = vocabularyData[currentIndexVocabulary]?.progresses.indexOf(
      currentVocabulary?.progressType,
    )

    if (i === -1) {
      setIndexProgress(0)
    } else {
      setIndexProgress(i)
    }
  }, [currentVocabulary, vocabularyData])

  const handleOpenModal = () => {
    if (
      entry_point === 'ROADMAP' &&
      !dataFeedbackOverview?.feedback_data[
        getFeedbackExitFlowType(location.pathname)
      ]?.is_completed
    ) {
      dispatch(updateIsShowModalExitFlow(true))
    } else {
      setIsOpenModal(true)
    }
  }

  const handleCancelModal = () => {
    setIsOpenModal(false)
  }

  const handleOke = () => {
    if (entry_point === 'ROADMAP') {
      navigate(PATH.HOME)
    } else {
      navigate(-2)
    }
  }

  return (
    <>
      <Flex
        justifyContent={'space-between'}
        alignItems={'center'}
        pt={'28px'}
        mb={'50px'}>
        <Flex w={'155px'} justifyContent={'center'}>
          <Image src={CloseIcon} cursor={'pointer'} onClick={handleOpenModal} />
        </Flex>
        <Box flex={1} mx={'100px'} display={{base: 'none', md: 'block'}}>
          <Stepper
            gap={'0px'}
            index={indexProgress}
            sx={{
              '.chakra-step__indicator': {
                bg: '#D9D9D9',
                border: '0px',
                w: '19px',
                h: '19px',
              },
              '.chakra-step': {
                gap: '0px',
              },
              '.chakra-step__indicator[data-status="complete"]': {
                backgroundColor: '#C9D7EA !important',
              },
              '.chakra-step__separator': {
                m: '0px !important',
              },
              '.chakra-step__title[data-status="active"],.chakra-step__title[data-status="complete"]':
                {
                  color: '#096DD9',
                },
            }}>
            {vocabularyData &&
              vocabularyData[currentIndexVocabulary]?.progresses.map(
                (step: any, index: any) => (
                  <Step key={index}>
                    <Box position={'relative'}>
                      <StepIndicator>
                        <StepStatus
                          complete={<Image src={CheckCompleteIcon} />}
                          active={<Image src={CheckActiveIcon} />}
                        />
                      </StepIndicator>
                      <Box
                        color={'#BFBFBF'}
                        flexShrink="0"
                        position={'absolute'}
                        top={'20px'}
                        left={'50%'}
                        transform={'translateX(-50%)'}
                        style={{textWrap: 'nowrap'}}>
                        <StepTitle style={{fontSize: '16px'}}>{step}</StepTitle>
                      </Box>
                    </Box>
                    <StepSeparator />
                  </Step>
                ),
              )}
          </Stepper>
        </Box>
        <Flex gap={'8px'} alignItems={'center'} w={'180px'}>
          <Image src={DocumentIcon} cursor={'pointer'} />
          <Text fontSize={'20px'} fontWeight={600} color={'#BFBFBF'}>
            {
              <Text as={'span'} color={'#FA8C16'}>
                Cụm {currentIndexVocabulary + 1}
              </Text>
            }{' '}
            / {vocabularyData?.length}
          </Text>
          <Icon
            w={'24px'}
            h="24px"
            viewBox="0 0 24 24"
            cursor={'pointer'}
            sx={{
              path: {
                fill: '#8c8c8c',
              },
            }}
            onClick={() => {
              dispatch(updateIsShowReportErrorForm(true))
            }}>
            <ExclamationCircle />
          </Icon>
        </Flex>
      </Flex>
      <Modal
        title={null}
        open={isOpenModal}
        onCancel={handleCancelModal}
        footer={null}
        width={420}
        styles={{
          content: {
            padding: '32px',
          },
        }}>
        <Flex gap={'16px'} alignItems={'start'}>
          <Icon w={'24px'} h="24px" viewBox="0 0 24 24">
            <path
              d="M12 0C5.37321 0 0 5.37321 0 12C0 18.6268 5.37321 24 12 24C18.6268 24 24 18.6268 24 12C24 5.37321 18.6268 0 12 0ZM12 21.9643C6.49821 21.9643 2.03571 17.5018 2.03571 12C2.03571 6.49821 6.49821 2.03571 12 2.03571C17.5018 2.03571 21.9643 6.49821 21.9643 12C21.9643 17.5018 17.5018 21.9643 12 21.9643Z"
              fill="#FAAD14"
              fillOpacity="0.85"
            />
            <path
              d="M10.7139 16.7143C10.7139 17.0553 10.8493 17.3823 11.0904 17.6234C11.3316 17.8645 11.6586 18 11.9996 18C12.3406 18 12.6676 17.8645 12.9087 17.6234C13.1498 17.3823 13.2853 17.0553 13.2853 16.7143C13.2853 16.3733 13.1498 16.0463 12.9087 15.8052C12.6676 15.564 12.3406 15.4286 11.9996 15.4286C11.6586 15.4286 11.3316 15.564 11.0904 15.8052C10.8493 16.0463 10.7139 16.3733 10.7139 16.7143ZM11.3567 13.7143H12.6424C12.7603 13.7143 12.8567 13.6179 12.8567 13.5V6.21429C12.8567 6.09643 12.7603 6 12.6424 6H11.3567C11.2389 6 11.1424 6.09643 11.1424 6.21429V13.5C11.1424 13.6179 11.2389 13.7143 11.3567 13.7143Z"
              fill="#FAAD14"
              fillOpacity="0.85"
            />
          </Icon>
          <Box>
            <Text fontWeight={600} fontSize={'16px'}>
              Bạn muốn dừng học
            </Text>
            <Text fontSize={'16px'} mt={'8px'}>
              Tiến trình học của bạn sẽ được lưu lại
            </Text>
          </Box>
        </Flex>
        <Flex gap={'16px'} justifyContent={'end'} mt={'24px'}>
          <Button
            borderRadius={'12px'}
            fontWeight={700}
            color={'#434343'}
            onClick={handleOke}>
            Tạm dừng
          </Button>
          <Button
            borderRadius={'12px'}
            bg={'#1890FF'}
            fontWeight={700}
            color={'white'}
            onClick={handleCancelModal}>
            Học tiếp
          </Button>
        </Flex>
      </Modal>
    </>
  )
}

export default Header
